import { useEffect, useState, useRef } from 'react';

export default function useDelayedState<T>(initialState: T) {
  const [state, setState] = useState<T>(initialState);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const setStateAfter = (newState: T | ((previousValue: T) => T), delay = 0) => {
    clearTimeout(timeoutRef.current);
    if (delay === 0 || delay === undefined) {
      setState(newState);
    } else {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setState(newState);
        timeoutRef.current = null;
      }, delay);
    }
  };

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return [state, setStateAfter] as const;
}
